export default function WeddingWeekendPage() {
  return (
    <main className="line-bottom">
      <div className="image-container">
        <img src="/images/house_guest_schedule.jpeg" alt="" />
      </div>
    </main>
  );
}
